ClubUsersController.$inject = [
    'CONST',
    '$scope',
    'Club',
    'User',
    '_',
    'alerts',
];

/* @ngInject */
function ClubUsersController(CONST, $scope, Club, User, _, alerts) {
    var vm = this;
    vm.title = 'ClubUsersController';

    var API = Club.API.one('users');

    // Constants
    vm.ROLES = {
        4: {
            id: 4,
            name: 'Encargado sin código',
        },
        3: {
            id: 3,
            name: 'Empleado',
        },
        2: {
            id: 2,
            name: 'Encargado',
        },
        1: {
            id: 1,
            name: 'Dueño',
        },
    };

    vm.loading = {
        all: true,
        new: false,
    };

    vm.isOwner = User.data.role === 1 || User.data.admin;
    vm.user_id = User.data.id;

    // List users

    vm.users = [];

    vm.getRoleName = function (user) {
        return vm.ROLES[user.role].name;
    };

    vm.getRoles = function () {
        if (vm.isOwner) {
            return vm.ROLES;
        }

        return _.pick(vm.ROLES, [3]);
    };

    // Delete
    vm.unlink = function (user) {
        if (user.id === vm.user_id) {
            return;
        }

        alerts
            .confirm('Estás por eliminar un usuario')
            .then(() => alerts.verifyCode(null, null, User))
            .then(unlink.bind(this, user));
    };

    // Edit role
    vm.edit = function (user, role) {
        alerts
            .verifyCode(null, null, User)
            .then(edit.bind(this, user, role))
            .catch((error) => {
                alerts.errorHandler(error);
            });
    };

    // Create new

    vm.addHidden = true;
    vm.create = {
        email: '',
        exists: false,
        valid: false,
        name: '',
        phone: '',
        id: null,
        role: 3,
    };

    vm.close = function () {
        reset_createFields(vm);
    };

    $scope.$watch('vm.create.email', function (newValue, oldValue) {
        if (newValue !== oldValue && vm.create.valid) {
            vm.create.valid = false;
            vm.create.exists = false;
            vm.create.id = null;
        }
    });

    vm.create.validate = checkUser;

    vm.store = function () {
        if (!vm.create.valid) {
            return;
        }

        if (vm.create.exists) {
            alerts
                .verifyCode(null, null, User)
                .then(link)
                .catch((error) => {
                    alerts.errorHandler(error);
                });
        } else {
            alerts
                .verifyCode(null, null, User)
                .then(create)
                .catch((error) => {
                    alerts.errorHandler(error);
                });
        }
    };

    activate();

    ////////////////

    function activate() {
        API.get()
            .then(function (users) {
                vm.users = _.map(users, function (user) {
                    vm.loading[user.id] = false;
                    return user;
                });
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.all = false;
            });
    }

    function reset_createFields(vm) {
        var c = vm.create;
        vm.addHidden = true;
        c.name = '';
        c.email = '';
        c.role = 3;
        c.valid = false;
        c.exists = false;
        c.phone = '';
        c.id = null;
        return c;
    }

    function checkUser() {
        vm.loading.new = true;
        API.customGET('check', {
            email: vm.create.email,
        })
            .then(function (res) {
                vm.create.valid = true;
                if (!res) {
                    vm.create.exists = false;
                } else {
                    vm.create.exists = true;
                    vm.create.id = res.id;
                    vm.create.name = res.name;
                }
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.new = false;
            });
    }

    /**
     * Removes the link user-club, so the user no longer administrates the club
     * @method unlink
     * @param  {Object} user
     * @param  {Number} code
     */
    function unlink(user, { code }) {
        vm.loading[user.id] = true;

        var data = link_formatData(user, code, true);

        Club.API.one('users', user.id)
            .customPUT(data, 'link')
            .then(function () {
                _.pull(vm.users, user);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading[user.id] = false;
            });
    }

    /**
     * Edits the role of the link user-club
     * @method edit
     * @param  {Object} user
     * @param  {Number} role
     * @param  {Number} code
     */
    function edit(user, role, { code }) {
        vm.loading[user.id] = true;

        var data = link_formatData(
            _.extend(user, {
                role: role,
            }),
            code,
            false,
            true,
        );
        Club.API.one('users', user.id)
            .customPUT(data, 'link')
            .then(function (user_edited) {
                user.role = role;
                vm.loading[user.id] = false;
                
                User.changeRole({ userId: user.id, newRole: role });
                alerts.success('¡Exito!', 'El rol del usuario se cambió con éxito');
               
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.new = false;
            });
    }

    /**
     * Links the vm.create user with the current sportclub under a specific role
     *
     * @method link
     * @param  {Number} code Four digit code
     */
    function link({ code }) {
        vm.loading.new = true;
        var data = link_formatData(vm.create, code);

        Club.API.one('users', vm.create.id)
            .customPUT(data, 'link')
            .then(function (usr) {
                alerts.success('¡Exito!', 'El usuario se asoció con éxito');
                vm.users.push(usr);
                reset_createFields(vm);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.new = false;
            });
    }

    function create({ code }) {
        vm.loading.new = true;
        var data = create_formatData(code);

        API.customPOST(data)
            .then(function (user) {
                alerts.success(
                    '¡Exito!',
                    'El usuario se creó con éxito. Se le envió un email para que complete su registro',
                    {
                        timeout: 2.5,
                    },
                );
                vm.users.push(user);
                reset_createFields(vm);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading.new = false;
            });
    }

    function link_formatData(user, code, del, update) {
        return {
            code: code,
            delete: del || false,
            update: update || false,
            email: user.email,
            role: user.role,
        };
    }

    function create_formatData(code) {
        var c = vm.create;
        return {
            code: code,
            name: c.name,
            email: c.email,
            phone: c.phone,
            role: c.role,
        };
    }
}

export default ClubUsersController;
